/** Render-only firewood. Stack bounds and interactions still come from the level. */
export const FIREWOOD = {
  piles: ['halkokatos', 'pirtin-klapipino', 'halkopino'] as readonly string[],
  seed: 0x4c415049,
  variants: 4,
  textureSize: 256,
  billetWidth: 0.24,
  billetHeight: 0.19,
  billetLength: 0.45,
  gap: 0.009,
  bark: 0x554334,
  split: 0xc59861,
  end: 0xd9b780,
} as const;
